import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IconComponent } from '@mode/capra';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent],
  selector: 'mode-my-work-empty-state',
  templateUrl: './my-work-empty-state.component.html',
  styleUrls: ['./my-work-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyWorkEmptyStateComponent implements OnChanges {
  @Input() emptyReports = false;
  @Input() noReports = false;
  public headerText = '';
  public messageText = '';

  ngOnChanges(): void {
    this.headerText = this.getHeaderText();
    this.messageText = this.getMessageText();
  }

  getHeaderText(): string {
    if (this.emptyReports && !this.noReports) {
      return 'Hmm...looks like there are no matching reports.';
    } else if (this.emptyReports && this.noReports) {
      return 'Your work lives here';
    }
    return "We'll let you get back to work";
  }
  getMessageText(): string {
    if (this.emptyReports && !this.noReports) {
      return 'Try using a different filter.';
    } else if (this.emptyReports && this.noReports) {
      return `Reports and Datasets you edit will appear here. To get started,
      use the quick actions above or click the plus button in the top right corner.`;
    }
    return 'Use the My Work tab to find your recent projects and jump back in.';
  }
}
